import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

// Components
import HomePage from "./components/HomePage";
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import CustomerSection from './components/CustomerSection';
import CatalogPage from "./components/CatalogPage";

// Utilities
import ProtectedRoute from "./utils/ProtectedRoute";
import { socket } from "./utils/socket";



// ----------------------------------------------------
// Main App Component
// ----------------------------------------------------
function App() {

	// ------------------------------------------------
	// Initialize and handle socket connections
    // ------------------------------------------------

    useEffect(() => {
        // Connect only if not already connected
        if (!socket.connected) socket.connect();
    
        // Named handlers for cleanup
        const handleConnect = () => { /* connection established */ };
        const handleAlert = (data) => { 
            // handle incoming alert data here
        };
    
        socket.on("connect", handleConnect);
        socket.on("alert", handleAlert);
    
        return () => {
            socket.off("connect", handleConnect);
            socket.off("alert", handleAlert);
        };
    }, []);


	// ------------------------------------------------
	// Render Router and Routes
	// ------------------------------------------------
	return (
		<Router>
			{/* Route definitions */}
			<Routes>
				<Route path="/" element={<HomePage />} />
				<Route path="/login" element={<Login />} />
				<Route path="/brochure" element={<CatalogPage />} />
				<Route
					path="/dashboard"
					element={
						<ProtectedRoute>
							<Dashboard />
						</ProtectedRoute>
					}
				/>
				<Route path="/customer" element={<CustomerSection />} />
			</Routes>
		</Router>
	);
}

export default App;
